import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'components/icon/icon';
import Icon from 'components/icon/icon';
import Typography from 'components/typography/typography';

interface BannerProps {
  title: string;
  variants: 'neutral' | 'warning' | 'success' | 'danger';
  iconProps?: IconProps;
  className?: string;
  typographyClassName?: string;
}

const styles = {
  danger: 'text-destructive bg-gray-100',
  neutral: 'text-gray-500 bg-gray-100',
  success: 'text-primary bg-[#EDFAF9]',
  warning: 'text-[#B59E14] bg-[#FAF8ED]',
};

const Banner: React.FC<BannerProps> = (props) => {
  const { title, variants, iconProps, className } = props;

  const bannerClassNames = twMerge(
    'flex flex-row items-center gap-1',
    'rounded-sm px-1 py-0.5 h-4',
    styles[variants],
    className,
  );

  const titleClassNames = twMerge(
    'uppercase font-semibold',
    props.typographyClassName,
  );
  const iconClassNames = twMerge(variants === 'neutral' && 'text-gray400');

  return (
    <div className={bannerClassNames}>
      {iconProps && (
        <Icon className={iconClassNames} size={11} {...iconProps} />
      )}
      <Typography variant="caption" as="p" className={titleClassNames}>
        {title}
      </Typography>
    </div>
  );
};

export default Banner;
